import { render, staticRenderFns } from "./StampItem.vue?vue&type=template&id=60105400&scoped=true&"
import script from "./StampItem.vue?vue&type=script&lang=js&"
export * from "./StampItem.vue?vue&type=script&lang=js&"
import style0 from "./StampItem.vue?vue&type=style&index=0&id=60105400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60105400",
  null
  
)

export default component.exports